import { FieldType } from '../enums';

export const displayedColumns: string[] = [
  'title',
  'lastEdition',
  'editor',
  'access',
  'more',
];

export const FORM_ELEMENTS = [
  { label: 'textBoxLabel', icon: 'insert_text', type: FieldType.TEXT },
  {
    label: 'singleChoiceLabel',
    icon: 'radio_button_checked',
    type: FieldType.SELECT,
  },
  {
    label: 'multipleChoiceLabel',
    icon: 'check_box',
    type: FieldType.MULTISELECT,
  },
  {
    label: 'filesMediaLabel',
    icon: 'add_photo_alternate',
    type: FieldType.FILE,
  },
  {
    label: 'locationLabel',
    icon: 'location_on',
    type: FieldType.LOCATION,
  },
  {
    label: 'sectionTitleLabel',
    icon: 'transition_slide',
    type: FieldType.SECTION,
  },
];

export const TRANSLATION_KEYS = {
  TEMPLATE_TITLE: 'editableFieldUntitledForm',
  TEMPLATE_DESCRIPTION: 'editableFieldFormDescription',
  QUESTION_TITLE: 'editableFieldUntitledQuestion',
  DESCRIPTION_TEXT: 'editableFieldOptionalDescription',
  ANSWER_TEXT: 'editableFieldAnswerText',
  FILE_FIELD_HELP_TEXT: 'fileUploadSizeLimit',
  LOCATION_TITLE: 'untitledLocation',
  TEMPLATE_CREATED: 'templateCreated',
  TEMPLATE_UPDATED: 'templateUpdated',
} as const;

export const DEFAULT_FIELD_OPTIONS = ['Option 1', 'Option 2'];

export const SNACKBAR_DURATION = 5000;
export const SNACKBAR_ACTION = $localize`:@@undo:Undo`;
export const SNACKBAR_DELETE_MESSAGE = 'formDeleted';

export const deleteFormDialogData = {
  title: 'deleteForm',
  content: 'deleteFormContent',
};
